<template>
    <Author 
        :author="editor"
        :text="reviewedByString"    
        class="reviewed-by-wrapper"
    />
</template>

<script>
import Author from '@/components/Author.vue';
export default {
    components: { Author },
    props: {
        documentEditor: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        editor() {
            const hasEditor = this.$validateContentRelationship(this.documentEditor);

            return hasEditor 
                ? this.$store.state.authors[this.documentEditor.id] 
                : null;
        },
        reviewedByString() {
            if (!this.editor) {
                return null;
            }
            
            return this.$translate('reviewed_by_editor', 'Granskad av {editor}')
                .replace('{editor}', `<span class="editor-name">${this.editor.data.name}</span>`);
        }
    }
};
</script>

<style lang="scss" scoped>
    .reviewed-by-wrapper::v-deep {
        display: flex;
        align-items: center;
        gap: .5rem;
        @include border(top);
        @include spacing(margin, 2, top);
        @include spacing(padding, 2, top);
        @include font-size(14px);
        text-decoration: none;
        color: $font;
        &:hover {
            .editor-name {
                color: $green;
            }
        }

        .author-image {
            border-radius: 50%;
        }
        .editor-name {
            font-weight: bold;
        }
    }
</style>